var React = require('react');
var dateFormat = require('dateformat');
var RichTextModule = require('../../RichText/RichTextModule');

// Styles
require('./PlayerHero.scss');

// Assets
var defaultImg = require('../../Players/default.png');

class PlayerHeroModule extends React.Component {

	createDescription = () => {
		return { __html: this.props.data.player.playerDescription };
	}

	render() {
		const images = this.props.data.player.backgroundImage;

		return (
			<div>
				<div className="PlayerHero" ref={hero => this.hero = hero} data-bg={images.smallUrl + '*,*' + images.mediumUrl + '*,*' + images.largeUrl + '*,*' + images.extraLargeUrl}>
					{this.props.data.player.backgroundVideo && this.props.data.player.backgroundVideo.length > 0 &&
						<div className="PlayerHero__video">
							<video className="lazy" autoPlay muted loop playsInline >
								{this.props.data.player.backgroundVideo.map(v => (
									<source key={v.type} data-src={v.src} type={v.type} />
								))}
							</video>
						</div>
					}
					<div className="PlayerHero__filter">
						<div className="PlayerHero__wrapper">
							<div className="PlayerHero__playerImage">
								<div className="PlayerHero__playerNumber">{this.props.data.player.playerNumber}</div>
								{this.props.data.player.playerImage !== null ? (
									<img data-src={this.props.data.player.playerImage.mediumUrl} alt={this.props.data.player.playerImage.altText} />
								) : (
										<img src={defaultImg} alt={"No photo for " + this.props.data.player.fullName} />
									)}
							</div>
							<div className="PlayerHero__playerMeta">
								<div className="PlayerHero__playerTable">
									<div className="PlayerHero__playerDetails">
										<h1><span className="firstName">{this.props.data.player.firstName} </span><span className="lastName">{this.props.data.player.lastName}</span></h1>
										<div className="statusIcon">
											{this.props.data.player.playerCountry &&
												<div className="flag">
													<img data-src={'/static/media/flags/4x3/' + this.props.data.player.playerCountry + '.svg'} alt={this.props.data.player.playerCountry + ' flag'} />
												</div>
											}
											{this.props.data.player.playerIsOnLoan &&
												<div className="loan">
													<span>On Loan</span>
												</div>
											}
										</div>
										{this.props.data.player.playerPosition && this.props.data.player.playerShowPosition &&
											<p className="no-spacing"><span>Position: </span>{this.props.data.player.playerPosition}</p>
										}
										{this.props.data.player.playerDateOfBirth &&
											<p className="no-spacing"><span>Born: </span>{dateFormat(this.props.data.player.playerDateOfBirth, "dd mmmm yyyy")}
												{this.props.data.player.playerPlaceOfBirth &&
													<span className="no-weight">&nbsp;({this.props.data.player.playerPlaceOfBirth})</span>
												}
											</p>
										}
										{this.props.data.player.playerJoinDate &&
											<p className="no-spacing"><span>Join Date: </span>{dateFormat(this.props.data.player.playerJoinDate, 'dd mmmm yyyy')}</p>
										}
										{this.props.data.player.playerDebut &&
											<p className="no-spacing"><span>Spurs Debut: </span>{dateFormat(this.props.data.player.playerSpursDebut, 'dd mmmm yyyy')}</p>
										}
										{this.props.data.player.playerProfessionalDebut &&
											<p className="no-spacing mobile"><span>Professional Debut: </span>{dateFormat(this.props.data.player.playerProfessionalDebut, 'dd mmmm yyyy')}</p>
										}
										{this.props.data.player.playerPreviousClubs.length > 0 &&
											<p className="no-spacing mobile"><span>Previous Clubs: </span>
												{this.props.data.player.playerPreviousClubs.map((club, index, arr) => <span className="no-weight prev-clubs" key={`${club}-${index}`}>{club}{index !== arr.length - 1 ? ',' : ''}</span>)}
											</p>
										}
										{this.props.data.player.tags &&
											<div className="PlayerHero__tags">
												{this.props.data.player.tags.map((tag, index) => {
													return(<a href={tag.url} rel="nofollow" key={index}>{tag.hashtag} </a>);
												})}
											</div>
										}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="PlayerAdditionalData-desktop">
					{/* <h2>{this.props.data.player.fullName}</h2> */}
					{this.props.data.player.playerProfessionalDebut &&
						<p className="no-spacing"><span>Professional Debut: </span>{dateFormat(this.props.data.player.playerProfessionalDebut, 'dd mmmm yyyy')}</p>
					}
					{this.props.data.player.playerPreviousClubs.length > 0 &&
						<p className="no-spacing"><span>Previous Clubs: </span>
							{this.props.data.player.playerPreviousClubs.map((club, index, arr) => <span className="no-weight prev-clubs" key={`${club}-${index}`}>{club}{index !== arr.length - 1 ? ',' : ''}</span>)}
						</p>
					}
				</div>
				{this.props.data.player.playerDescription &&
					<RichTextModule className="PlayerHero__playerBio" data={{
						isLoadMore: true,
						content: this.props.data.player.playerDescription,
					}}/>
				}
			</div>
		)
	}
}

module.exports = PlayerHeroModule;



// WEBPACK FOOTER //
// ./src/components/Hero/PlayerHero/PlayerHeroModule.js